var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 13.9998C7.84449 13.9998 7.68615 13.9715 7.52504 13.9149C7.36393 13.8583 7.22226 13.7678 7.10004 13.6433L5.95004 12.574C4.77226 11.4764 3.70837 10.3873 2.75837 9.30669C1.80837 8.22606 1.33337 7.03512 1.33337 5.73384C1.33337 4.67019 1.68337 3.78193 2.38337 3.06906C3.08337 2.35619 3.9556 1.99976 5.00004 1.99976C5.58893 1.99976 6.14449 2.12705 6.66671 2.38165C7.18893 2.63625 7.63337 2.9842 8.00004 3.4255C8.36671 2.9842 8.81115 2.63625 9.33337 2.38165C9.8556 2.12705 10.4112 1.99976 11 1.99976C12.0445 1.99976 12.9167 2.35619 13.6167 3.06906C14.3167 3.78193 14.6667 4.67019 14.6667 5.73384C14.6667 7.03512 14.1945 8.22889 13.25 9.31517C12.3056 10.4015 11.2334 11.4934 10.0334 12.591L8.90004 13.6433C8.77782 13.7678 8.63615 13.8583 8.47504 13.9149C8.31393 13.9715 8.1556 13.9998 8.00004 13.9998Z",
    fill: "#252153"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.de83afe6f6283b929b2b9d4add4d5e26.svg";
export { ForwardRef as ReactComponent };